import { ReactComponent as BackIcon } from "@preownedfront/lib-reowds/icons/24/arrow-left.svg";
import { ReactComponent as DismissIcon } from "@preownedfront/lib-reowds/icons/24/dismiss.svg";
import React from "react";
import './mobile-page.scss';
import { string } from "prop-types";
import { useTranslation } from "react-i18next";


export interface ContainerProps {
    children: React.ReactNode;
    className?: string;
    placement?: "LEFT" | "RIGHT" | "TOP" | "BOTTOM";
    defaultPage?: boolean;
    defaultHeader?: boolean;
    defaultContent?: boolean;
    refElement?: React.MutableRefObject<HTMLDivElement | null>;
    scrollDisabled?: boolean;
}
export interface MobilePageTitleProps extends ContainerProps {
    id?: string;
}
export const GLOBAL_BACK_ICON = {
    ARROW: 'arrow',
    CLOSE: 'close'
}

export type MobileBackIcon = typeof GLOBAL_BACK_ICON[keyof typeof GLOBAL_BACK_ICON];

export const MobilePage = ({ children, className, defaultPage = true }: ContainerProps) => (
    <div className={`pds-modal  pds-dialog--size-s pds-dialog--no-actions ${defaultPage ? 'pds-dialog pds-drawer pds-drawer--bottom' : ''} ${className ?? ''}`}>
        <div className="pds-backdrop"></div>
        <div className="pds-dialog__focus-trap pds-drawer__content" tabIndex={-1}>
            <div className={`pds-dialog__wrapper pds-drawer__container ${defaultPage ? 'pds-drawer--size-m' : ''}`}>
                {children}
            </div>
        </div>
    </div>
);

MobilePage.Header = ({ children, className, defaultHeader = true }: ContainerProps) => (
    <div className={`${className ?? ''} ${defaultHeader ? 'pds-drawer-header profile__header pds-drawer-header--has-return-button' : ''}`}>
        {children}
    </div>
);

MobilePage.Title = ({ children, className, id = "" }: MobilePageTitleProps) => (
    <h1 className={`pds-drawer-title ${className ?? ''}`} id={id}>
        {children}
    </h1>
);

export interface MobilePageCloseButtonProps {
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    type?: MobileBackIcon;
    ariaLabel?:string;
}

MobilePage.CloseButton = ({ className, onClick, type = 'close', ariaLabel }: MobilePageCloseButtonProps) => {
    const { t } = useTranslation();

    const defaultAriaLabel = type === 'close'
        ? t("call_alert_close")   
        : t("nav_icons_back");   

    return (
        <button
            className={`pds-dialog-icon-button pds-dialog-close-button pds-drawer-close-button header-wm-icon ${className ?? ''}`}
            onClick={onClick}
            aria-label={ariaLabel ?? defaultAriaLabel}
        >
            {type === 'close'
                ? <DismissIcon className="header-wm-icon__icon" />
                : <BackIcon className="header-wm-icon__icon" />}
        </button>
    );
};

MobilePage.Content = ({ children, className, defaultContent = true, refElement = null, scrollDisabled = false}: ContainerProps) => (
    <div ref={refElement} className={`${className ?? ''} ${defaultContent ? 'pds-dialog-content pds-drawer-content' : 'content-scrol--not-display'} ${scrollDisabled ? "scroll-disabled" : ""}`}>
        {children}
    </div>
);